import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import WifiIcon from '../../../assets/Images/Marketing/colored yt icon element.svg';
import MetaIcon from '../../../assets/Images/Marketing/colored meta .svg';
import PlayIcon from '../../../assets/Images/Marketing/color spotify icon element.svg';
import wave from '../../../assets/Images/Marketing/graph element.svg'
import './MusicMarketingFourthSection.scss';
import UnifiedButton from '../../shared/Button';
import { useNavigate } from 'react-router-dom';

const MusicMarketingFourthSection = () => {


    const navigate = useNavigate()


    const handleplaylistformClick = () => {
        navigate('/support/legal-forms/3');
        window.scrollTo(0, 0);
    };

    return (
        <Box className="music-marketing-fourth-section" sx={{ py: 8 }}>
            <Container>
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <Box className="left-section">
                            <img src={WifiIcon} alt="Wifi Icon" className="icon-wifi" />
                            <img src={MetaIcon} alt="Meta Icon" className="icon-meta" />
                            <img src={PlayIcon} alt="Play Icon" className="icon-play" />
                            <img src={wave} alt="Wave Icon" className="wave-line" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box className="right-section" sx={{ p: 4, bgcolor: '#fce7ff', borderRadius: 4 }}>
                            <Typography variant="h4" component="h2" gutterBottom>
                                Release Strategy
                            </Typography>
                            <Typography paragraph>
                                We’re committed to optimizing the success of your releases.
                            </Typography>
                            <Typography paragraph>
                                Benefit from expert advice to enhance your campaigns. Our label services team, with decades of experience in promoting both global icons and rising talents, is here to support you.
                            </Typography>
                            <Typography paragraph>
                                FM Digital Official partners with you to craft a tailored release strategy that adapts to your evolving business needs.
                            </Typography>
                            <UnifiedButton onClick={handleplaylistformClick} className="cta-button" textContent={" Apply Now"} />


                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default MusicMarketingFourthSection;
